export const TOTAL_RATING = 4.9;
export const MAXIMUM_RATING = 5;

export const TESTIMONIAL_SECTION_TITLE = 'Check out what our <b>users</b> are saying';
